import React from 'react';
import './individualInformHeader.css'
import { Card } from 'antd';

const IndividualInformHeader = ({ individualResult, orgLogo }) => {
    return (
        <div className="individual-inform-header-wrapper">
            <div className="individual-inform-header-logo">
                <img src={orgLogo} alt="Logo" />
            </div>

            <div className="individual-inform-header-divider" />

            <div className="individual-inform-header-info">
                <div className="individual-inform-header-label">Nombre:</div>
                <div className="individual-inform-header-name">{`${individualResult.first_name} ${individualResult.last_name}`}</div>

                <div className="individual-inform-header-label">Cargo:</div>
                <div className="individual-inform-header-role">{individualResult.job_title}</div>
            </div>
        </div>
    );
};

export default IndividualInformHeader;